import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ChevronRightIcon = ({ size  })=>size === "small" ? /*#__PURE__*/ _jsxs("svg", {
        width: "12",
        height: "22",
        viewBox: "0 0 12 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "chevron-right-small"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.5 1.66658L10.8333 10.9999L1.5 20.3333",
                stroke: "#5234B6",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }) : /*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "36",
        viewBox: "0 0 20 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "chevron-right-large"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.75 1.08329L18.6667 18L1.75 34.9166",
                stroke: "#5234B6",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
